var VALIDATION = {
    Numeric: function(input) { return input.match(/^[0-9]+$/) !== null; },
    inputErrorTypes: {
        invalid: "Invalid Input",
        notFound: "Not Found"
    }
};

module.exports = {
    VALIDATION,
    inputErrorTypes: VALIDATION.inputErrorTypes
};